export interface IAccountInfo {
    email: string;
}

export class Login implements IAccountInfo {
    email: string;
    password: string;
    inviteToken?: string;
}

export class Register implements IAccountInfo {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    changePassword: string;
    confirmPassword: string;
    timezone: string;
    orgId: number;
    inviteToken?: string;
}

export class ChangePassword implements IAccountInfo {
    email: string;
    oldPassword: string;
    newPassword: string;
    confirmPassword: string;
}

export class ResetPassword {
    userId: string;
    code: string;
    password: string;
    confirmPassword: string;
}

export class ForgotPassword {
    email: string;
}

export class ExternalAuthRequest {
    provider: string;
    idToken: string;
    firstName?: string;
    lastName?: string;
    timeZone?: string;
    inviteToken?: string;
}

export interface OAuthStatePayload {
    provider: 'google' | 'microsoft';
    context: 'login' | 'register';
    inviteToken?: string;
    returnUrl?: string;
    nonce: string;
}

export class Token {
    access_token: string;
    token_type: string;
    expires_in: number;
    userName: string;
}
